import React, { memo, useCallback, useMemo } from 'react';
import { Tour } from '@web/web5';
import { ACTIVITIES } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';
import { setNewToursObj } from 'utils/tours';

const ExportButtonTour = memo(({ id }) => {
    const stepsTourExportButton = useMemo(() => {
        return [
            {
                selector: '.fm-activites-tabs__dropdown-toggle',
                title: getLiteral('label_promotion_activities_cross_export_title'),
                description: getLiteral('label_promotion_activities_cross_export_body'),
                event: 'tour:end',
            },
        ];
    }, []);

    const onCloseTourExportButton = useCallback(() => {
        if (!id) return;
        setNewToursObj({ entity: ACTIVITIES, tourName: id });
    }, [id]);

    return <Tour steps={stepsTourExportButton} delay={1000} onClose={onCloseTourExportButton} />;
});

export default ExportButtonTour;
